var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBringToFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.28573,
    y: 7.71408,
    width: 12,
    height: 12,
    rx: 1.71429,
    stroke: "black",
    strokeWidth: 1.71429
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.857143,
    y: 11.1428,
    width: 12,
    height: 12,
    rx: 1.71429,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.71429
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42861 5.143H18C18.4734 5.143 18.8572 5.52675 18.8572 6.00014V14.5716C18.8572 15.045 18.4734 15.4287 18 15.4287H17.1429V17.143H18C19.4202 17.143 20.5715 15.9917 20.5715 14.5716V6.00014C20.5715 4.57998 19.4202 3.42871 18 3.42871H9.42861C8.00845 3.42871 6.85718 4.57998 6.85718 6.00014V6.85728H8.57146V6.00014C8.57146 5.52675 8.95522 5.143 9.42861 5.143Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8572 1.71429H21.4286C21.902 1.71429 22.2858 2.09804 22.2858 2.57143V11.1429C22.2858 11.6162 21.902 12 21.4286 12H20.5715V13.7143H21.4286C22.8488 13.7143 24.0001 12.563 24.0001 11.1429V2.57143C24.0001 1.15127 22.8488 0 21.4286 0H12.8572C11.437 0 10.2858 1.15127 10.2858 2.57143V3.42857H12.0001V2.57143C12.0001 2.09804 12.3838 1.71429 12.8572 1.71429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringToFront);
export default __webpack_public_path__ + "static/media/bringToFront.4e5985031b3e048eff935ec5ba7e9252.svg";
export { ForwardRef as ReactComponent };